export function messagesHaveLevel(messages, level) {
  return !!messages.find(m => m.level === level);
}



// WEBPACK FOOTER //
// ./src/models/utils.js